export default (params) => ({
  trigger: {
    name: 'configurator.select_usage_situation',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'configurator_pills',
      },
    },
  },
});
